<template>
    <div class="resetPwd-container">
        <el-card>
            <div class="reset-form-div">
                <el-form :model="form" :rules="rules" ref="form" size="mini" label-position="left" label-width="100px">
                    <el-form-item label="当前密码:" prop="password">
                        <el-input v-model="form.password" type="password" placeholder="请输入" size="mini" class="div-input"></el-input>                    
                    </el-form-item>
                    <el-form-item label="新密码:" prop="newPassword">
                        <el-input v-model="form.newPassword" type="password" placeholder="请输入" size="mini" class="div-input"></el-input>                    
                    </el-form-item>                
                    <el-form-item label="确认新密码:" prop="checkPassword">
                        <el-input v-model="form.checkPassword" type="password" placeholder="请输入" size="mini" class="div-input"></el-input>                    
                    </el-form-item>
                </el-form>
            </div>
            <div class="resetPwd-but-div">
                <el-button size="mini" class="resetPwd-but" type="primary" @click="resetPwd()" :disabled="form.loading">保存</el-button>
                <el-button size="mini" class="resetPwd-but" type="plain" @click="reset()" :disabled="form.loading">重置</el-button>
            </div>
        </el-card>
    </div>
</template>
<script>
    import {Message} from 'element-ui'
    export default {       
        data() {
            const validatePasswordOld = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('密码不能为空，请输入有效的密码。'));
                }
                if(value.length < 8){
                    return callback(new Error('密码长度不足，请至少输入 8 个字符。'));
                }
                if(value.length > 20){
                    return callback(new Error('密码长度不得超过 20 个字符。'));
                }
                const hasUpperCase = /[A-Z]/.test(value);
                const hasLowerCase = /[a-z]/.test(value);
                const hasNumber = /\d/.test(value);
                const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);
                const validCount = [hasUpperCase, hasLowerCase, hasNumber, hasSpecialChar].filter(Boolean).length;
                if (validCount < 2) {
                    return callback(new Error('密码需包含大写字母、小写字母、数字和特殊字符中的两类。'));
                }
                callback();
            };
            const validatePassword = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('密码不能为空，请输入有效的密码。'));
                }
                if(value.length < 8){
                    return callback(new Error('密码长度不足，请至少输入 8 个字符。'));
                }
                if(value.length > 20){
                    return callback(new Error('密码长度不得超过 20 个字符。'));
                }
                const hasUpperCase = /[A-Z]/.test(value);
                const hasLowerCase = /[a-z]/.test(value);
                const hasNumber = /\d/.test(value);
                const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);
                const validCount = [hasUpperCase, hasLowerCase, hasNumber, hasSpecialChar].filter(Boolean).length;
                if (validCount < 3) {
                    return callback(new Error('密码需包含大写字母、小写字母、数字和特殊字符中的三类。'));
                }
                callback();
            };
            const validateCheckPassword = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('请再次输入密码'));
                }
                if (value !== this.form.newPassword) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return {
                form: {
                    password:'',
                    newPassword:'',
                    checkPassword:'',
                    loading:false,
                },
                rules:{
                    password:[
                        {required: true, message: '密码不能为空，请输入有效的密码。', trigger: 'blur'},
                        {validator: validatePasswordOld, trigger: 'blur'}
                    ],
                    newPassword:[
                        {required: true, message: '密码不能为空，请输入有效的密码。', trigger: 'blur'},
                        {validator: validatePassword, trigger: 'blur'}
                    ],
                    checkPassword:[
                        {required: true, message: '密码不能为空，请输入有效的密码。', trigger: 'blur'},
                        {validator: validatePassword, trigger: 'blur'},
                        {validator: validateCheckPassword, trigger: 'blur'}
                    ]
                }
            }
        },
        methods:{
            reset(){
                this.form = {
                    password:'',
                    newPassword:'',
                    checkPassword:'',
                    loading:false,
                }
                this.resetForm('form')
            },
            resetPwd(){
                this.$refs['form'].validate((valid) => {
                if (valid) {
                   this.setPassword()                       
                } else {
                    return false;
                }
            }); 
				
            },
            setPassword(){
                let data = {
                    "old_password":this.$md5(this.form.password), // 当前密码
                    "password": this.$md5(this.form.newPassword), // 新密码
                    "password2": this.$md5(this.form.checkPassword)// 确认新密码
                }
                this.form.loading = true
                this.$api.setPassword(data).then(res=>{
                    this.form.loading = false
                    if(res.status == 1){
                        this.logout()
                        this.$router.push('./login')

                    }else{
                        Message({
                            message:res.msg,
                            type:"error",
                            duration: 3 * 1000
                        })
                    }
                }).catch(e=>{                    
                    this.form.loading = false
                })
            },
             //重置表单
             resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            logout(){
                let data = {
                    username:this.$local.get('username')
                }
                this.$api.logout(data).then(res=>{
                    this.$local.remove('tid')
                    this.$local.remove('username')
                    if(res.status !=1){
                        Message({
                            message:res.msg,
                            type:"error",
                            duration: 3 * 1000
                        })
                    }
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .resetPwd-container{
        padding-left: 42px;
        padding-top: 32px;
        max-width: 600px;
        .div-input{
            width: 200px;
        }
        .resetPwd-but-div{
            padding-left: 100px;
            .resetPwd-but{
                width:80px;
                height: 30px;
            }
        }
    }
</style>